var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"position-direction",class:_vm.type % 2 ? 'red' : 'green'},[_vm._v(" "+_vm._s(_vm.orderTypeString(_vm.type))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }